export default __webpack_public_path__ + "static/media/brave_zone_m2.0f7eda47.png";